import { useEffect } from 'react';
import Filtros from './components/Filtros';
import { styles, UserContainer, StyledTable } from './components/reportesComponents';
import Card from '../components/Card/Card';
import CardHeader from '../components/Card/CardHeader';
import CardBody from '../components/Card/CardBody.js';
import { makeStyles } from '@mui/styles';
import { columns, customStyles, opcionesdepagina } from './components/tableOptions';
import ExpandableComponent from './components/ExpandableComponent';
import EncabezadoReportes from './components/EncabezadoReportes';
import { ReportesContext } from '../context/ReportesContext';
import { useContext } from 'react';
import Botones from './components/botenes';
const useStyles = makeStyles(styles);

function Reportes() {
  const classes = useStyles();

  const { ventas, obtenerDatosDelReporte } = useContext(ReportesContext);

  useEffect(() => {
    obtenerDatosDelReporte();
  }, []);

  return (
    <UserContainer>
      <Card>
        <CardHeader color='danger'>
          <h2 className={classes.cardTitleWhite}>Reportes</h2>
          <p className={classes.cardCategoryWhite}>Información útil acerca del negocio</p>
        </CardHeader>
        <CardBody>
          <EncabezadoReportes />

          <Filtros setVentasFiltradas={[]} />
          <>
            {ventas.length !== 0 ? <Botones data={ventas} /> : null}
            <StyledTable
              responsive
              expandableRows
              expandableRowsComponent={ExpandableComponent}
              expandOnRowClicked
              columns={columns}
              data={ventas}
              customStyles={customStyles}
              pagination
              paginationComponentOptions={opcionesdepagina}
              paginationRowsPerPageOptions={[10, 25, 50, 100, 1000]}
              fixedHeader
              fixedHeaderScrollHeight='600px'
              highlightOnHover
              noDataComponent={<div>No hay informacion disponible para mostrar</div>}
            />
          </>


        </CardBody>
      </Card>
    </UserContainer>
  );
}

export default Reportes;
